module.exports = __webpack_public_path__ + "media/images/store/google_play-0bd58362dee89a9c0e5006858305c7bf.png";